module.exports = __webpack_public_path__ + "img/avatar-84.e1ac1126.png";